export default "__VITE_ASSET__CeVwskHN__"